function docReady() {
}

function docLoad() {
}